import React, { Component } from "react";

import MainLayoutWithNav from "../layout/MainLayoutWithNav";
import Navigation from "../layout/Navigation";
import Header from "../sections/Section-Header/Header";
import About from "../sections/Section-About/About";
import Features from "../sections/Section-Features/Features";
import Portfolio from "../sections/Section-Portfolio/Portfolio";
import Stories from "../sections/Section-Stories/Stories";
import Footer from "../sections/Section-Footer/Footer";

class MainPage extends Component {
  render() {
    return (
      <MainLayoutWithNav
        screens={
          <div>
            <Navigation />
            <Header />
            <About />
            <Features />
            <Portfolio />
            <Stories />
            <Footer />
          </div>
        }
      />
    );
  }
}

export default MainPage;



// WEBPACK FOOTER //
// ./src/components/pages/MainPage.js